import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {BASHomepageBannerView} from './BASHomepageBannerView';
import {useFixedHeader} from './useFixedHeader';

export const BASHomepageBanner: React.FC<{sectionIndex?: number}> = props => (
  <DataFetcher
    request={useFixedHeader()}
    View={BASHomepageBannerView}
    Error={() => null}
    viewProps={props}
  />
);
